export const SDK_VERSION = '7.92.0';
